import React from 'react'
import { useTranslation } from 'react-i18next'
import ContactForm from './ContactForm'
import { Icon99, TruckIcon, CustomerSupportIcon, PhoneIcon } from '../../../images/svg'



const BusinessContact = () => {
  const { t } = useTranslation()
  return (
    <section className="business-contact-section same-common elink-container">
      <ContactForm />
      <div className="business-advantages-section">
        <h2 className="advantages-heading">{t('businessContact.heading1')} <br/>{t('businessContact.heading2')}</h2>
        <div className="business-card-items">

          <div className="business-card-item">
            <div className="business-card-icons"><Icon99 /></div>
            <div className="business-advantage-details">
              <h3 className="business-advantage-title">{t('businessContact.uptimeTitle')}</h3>
              <p className="business-advantage-description">{t('businessContact.uptimeDesc')}</p>
            </div>
          </div>

          <div className="business-card-item">
            <div className="business-card-icons"><TruckIcon /></div>
            <div className="business-advantage-details">
              <h3 className="business-advantage-title">{t('businessContact.installTitle')}</h3>
              <p className="business-advantage-description">{t('businessContact.installDesc')}</p>
            </div>
          </div>

          <div className="business-card-item">
            <div className="business-card-icons"><CustomerSupportIcon /></div>
            <div className="business-advantage-details">
              <h3 className="business-advantage-title">{t('businessContact.supportTitle')}</h3>
              <p className="business-advantage-description">{t('businessContact.supportDesc')}</p>
            </div>
          </div>

          <div className="business-card-item">
            <div className="business-card-icons"><PhoneIcon /></div>
            <div className="business-advantage-details">
              <h3 className="business-advantage-title">{t('businessContact.accountTitle')}</h3>
              <p className="business-advantage-description">{t('businessContact.accountDesc')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BusinessContact
